module.exports = __webpack_public_path__ + "img/制御工学4_7.184db178.png";